import { useContext } from 'react';
import { CollectionReportContext } from '../Contexts/CollectionReportContext';

export const useCollectionReport = () => useContext(CollectionReportContext);
